import { plugin } from 'light-component';
import { Icons, useTranslation } from '@common';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function WidgetNoData(): ReactElement {
  const [t] = useTranslation();

  return (
    <div className={styles.emptyBox}>
      <Icons name='EmptyIcon' />
      <span className={styles.emptyText}>
        {t('暂无数据')}
      </span>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'nodata', component: WidgetNoData });
